import initStart from './components/init-quiz'

function init(): void {
  initStart()
}

init()
